import api from './api';

// A Google listing shown while a provider picks theirs; only its place_id is saved
export interface GoogleListingCandidate {
  place_id: string;
  name: string;
  address: string | null;
}

// Fetched live from Google on each view; never stored or part of the CLOUT score
export interface GoogleRating {
  name: string | null;
  rating: number | null;
  user_rating_count: number;
  google_maps_uri: string | null;
}

export const googleListingApi = {
  search: async (query: string): Promise<GoogleListingCandidate[]> => {
    const response = await api.get('/api/providers/me/google-listing/search', {
      params: { q: query },
    });
    return response.data;
  },

  link: async (placeId: string): Promise<{ google_place_id: string | null }> => {
    const response = await api.put('/api/providers/me/google-listing', { place_id: placeId });
    return response.data;
  },

  unlink: async (): Promise<void> => {
    await api.delete('/api/providers/me/google-listing');
  },

  getRating: async (providerId: number): Promise<GoogleRating> => {
    const response = await api.get(`/api/providers/${providerId}/google-rating`);
    return response.data;
  },
};
